import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../constants/url";
import styled from "styled-components";
import { jwtDecode } from "jwt-decode";
import { api } from "../constants/api";
import { getAvailableSlots } from "../components/SlotBooking";

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  flex-direction: column;
  gap: 1rem;
`;

const Loader = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const Message = styled.div`
  font-size: 1.2rem;
  color: #333;
  text-align: center;
`;

const redirectToSlotBooking = (statusMessage, setLoading, setStatusMessage) => {
  setLoading(false);
  setStatusMessage(statusMessage);
  setTimeout(() => {
    // window.location.assign("http://192.168.1.40:7000/admin/slotBooking");
    window.location.assign("https://app.summairsportsclub.org/admin/slotBooking");
  }, 5000);
};

const Payment = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statusMessage, setStatusMessage] = useState("");
  const location = useLocation();

  useEffect(() => {
    const validateAndInitiatePayment = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const userToken = params.get("userToken");
        const amount = params.get("amount");
        const orderId = params.get("order_id");
        const memberCode = params.get("memberCode");
        const memberId = params.get("memberId");
        const slotBookingId = params.get("slot_booking_id");

        if (!amount || !orderId) {
          throw new Error("Missing required parameters");
        }
        const response = await axios.post(
          `${baseUrl}/ccavRefundRequestHandler`,
          {
            amount: parseFloat(amount).toFixed(2).toString(),
            order_no: orderId,
          },
          {
            headers: {
              Authorization: `Bearer ${userToken}`,
              memberId,
              memberCode,
            },
            responseType: "text",
          }
        );
        if (response.data.refund_status === 0) {
          try {
            const res = await api(true, `/admin/cancelSlot`, "post", {
              user_id: memberId,
              slot_booking_id: slotBookingId,
              status: 'refund'
            });
            redirectToSlotBooking("Payment Refunded Successfully!", setLoading, setStatusMessage);
          } catch (error) {
            redirectToSlotBooking("Payment refund is done but updating slot booking status failed!", setLoading, setStatusMessage);
          }
        } else {
          redirectToSlotBooking("Payment Refund Failed!", setLoading, setStatusMessage);
        }
      } catch (err) {
        console.error("Payment error:", err.response.data);
        if (err.response.data.reason !== '') {
          redirectToSlotBooking(err.response.data.reason, setLoading, setStatusMessage);
        } else {
          redirectToSlotBooking("Payment Refund Failed!", setLoading, setStatusMessage);
        }
      }
    };

    validateAndInitiatePayment();
  }, [location]);

  if (loading) {
    return (
      <Container>
        <Loader />
        <Message>Loading...</Message>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Message style={{ color: "red" }}>Error: {error}</Message>
      </Container>
    );
  }

  return (
    <Container>
      <Loader />
      <Message>{statusMessage}</Message>
      <Message>Redirecting to slot booking...</Message>
    </Container>
  );
};

export default Payment;
